<template>
  <div
    class="order-planner-calendar-scheduler__event order-planner-backlog__item rounded-sm p-25 pl-50 h-100"
    :class="{
      'order-planner-calendar-scheduler__event--assigned': eventData.isAssigned,
      'order-planner-calendar-scheduler__event--first-available': eventData.isFirstAvailablePlanning,
    }"
    :data-order-id="eventData.orderId"
  >
    <div
      v-if="eventData.isFirstAvailablePlanning"
      class="order-planner-calendar-scheduler__event-first-available-badge font-small-1 font-weight-bold text-uppercase mb-25"
    >
      Pierwszy wolny
    </div>
    <div
      v-if="eventData.isAssigned"
      class="font-small-1 font-weight-bold text-uppercase text-muted mb-25"
    >
      {{ eventData.statusLabel }}
    </div>
    <div class="font-small-2 text-muted mb-n25 text-nowrap">
      {{ eventData.scheduledAtLabel }}
    </div>

    <span class="font-small-3 text-primary text-nowrap">
      {{ eventData.title }}
    </span>

    <div
      v-if="eventData.pickupAddressLabel || eventData.deliveryAddressLabel"
      class="font-small-1 text-muted mt-25"
    >
      <div class="d-flex align-items-center">
        <feather-icon
          icon="ArrowUpCircleIcon"
          size="13"
          class="mr-25 flex-shrink-0 text-success"
        />
        <span class="mr-50">{{ eventData.pickupAddressLabel }}</span>
      </div>
      <div class="d-flex align-items-center">
        <feather-icon
          icon="ArrowDownCircleIcon"
          size="13"
          class="mr-25 flex-shrink-0 text-danger"
        />
        <span>{{ eventData.deliveryAddressLabel }}</span>
      </div>
    </div>

    <div class="d-flex align-items-center flex-shrink-0 mt-50">
      <div class="d-flex align-items-center text-muted">
        <b-avatar
          v-if="eventData.returnTransport"
          :title="'Transport w obie strony'"
          size="18"
          variant="info"
          class="mr-25"
        >
          <feather-icon
            icon="RepeatIcon"
            size="12"
          />
        </b-avatar>
        <b-avatar
          v-if="eventData.prioritySignals"
          :title="'Przejazd na sygnalach uprzywilejowania'"
          size="18"
          variant="primary"
          class="mr-25"
        >
          <feather-icon
            icon="LoaderIcon"
            size="12"
          />
        </b-avatar>
        <b-avatar
          v-if="eventData.absolutePunctuality"
          :title="'Nie mozna sie spoznic'"
          size="18"
          variant="danger"
          class="mr-25"
        >
          <feather-icon
            icon="ClockIcon"
            size="12"
          />
        </b-avatar>
        <b-avatar
          v-if="eventData.infectious"
          :title="'Zakazny'"
          size="18"
          variant="warning"
          class="mr-25"
        >
          <feather-icon
            icon="AlertTriangleIcon"
            size="12"
          />
        </b-avatar>
        <b-avatar
          v-if="eventData.private"
          :title="'Prywatny'"
          size="18"
          variant="success"
          class="mr-25"
        >
          <feather-icon
            icon="DollarSignIcon"
            size="12"
          />
        </b-avatar>
      </div>
    </div>
  </div></template>

<script>
import { defineComponent } from '@vue/composition-api'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default defineComponent({
  name: 'PlannerSchedulerEventCard',
  components: { FeatherIcon },
  props: { eventData: { type: Object, required: true } },
})
</script>
